import { mapArrayElement } from "../../common";
import { mapStatistics } from "./mapSportsbookMarket";
import { mapParticipantStatistic } from "./mapSportsbookSelections";
function mapOutcome(data) {
    return {
        providerOutcomeId: data[0],
        label: data[1],
        providerOfferId: data[2],
        oddsAmerican: data[3],
        oddsDecimal: data[4],
        oddsDecimalDisplay: data[5],
        oddsFractional: data[6],
        line: data[7],
        participant: data[8],
        main: data[9],
        dkPlayerId: data[10] || undefined,
        playerStatistic: mapArrayElement(data[13], mapParticipantStatistic),
    };
}
export function mapOffer(data) {
    return {
        providerOfferId: data[0],
        label: data[1],
        eventId: data[2],
        eventGroupId: data[3],
        displayGroupId: data[4],
        offerSubcategoryId: data[5],
        betOfferTypeId: data[6],
        isSuspended: data[7],
        outcomes: data[8] ? data[8].map(mapOutcome) : undefined,
        dkPlayerId: data[9] || undefined,
        tags: data[10],
        statistics: mapStatistics(data[11]),
        correlatedId: data[12],
        playerStatistic: mapArrayElement(data[13], mapParticipantStatistic),
    };
}
//# sourceMappingURL=mapOffer.js.map